import { Trans } from 'react-i18next';
import LanguageButton from './LanguageButton';
import ukraine from '../images/ukraine.svg';
import uk from '../images/uk.svg';
import { ONLINE_ACADEMY_URL, SUPPORT_US_URL } from '../data/NavigationData';

// Thin dark strip above the main menu: phone, "established" text,
// language switch and (desktop only) the two external buttons.
// On mobile the buttons live inside the drawer instead (see SideBar.js).
function UtilityBar({ showButtons }) {
    return (
        <div className="utilityBar">
            <div className="utilityBarInner">
                <div className="utilityBarInfo">
                    <a href="tel:+442037954966"><Trans i18nKey="Call Us" /></a>
                    {/* hidden on small screens via CSS to save space */}
                    <span className="utilityBarLong">
                        <Trans i18nKey="Established" />
                    </span>
                </div>
                <div className="utilityBarActions">
                    <LanguageButton localisation="en" logo={uk} alt="UK flag" />
                    <LanguageButton localisation="ua" logo={ukraine} alt="Ukrainian flag" />
                    {showButtons && (
                        <>
                            <a className="navBtn navBtnOutline" href={ONLINE_ACADEMY_URL} target="_blank" rel="noreferrer">
                                <Trans ns="navigation" i18nKey="Online Academy" />
                            </a>
                            <a className="navBtn navBtnSupport" href={SUPPORT_US_URL} target="_blank" rel="noreferrer">
                                <Trans ns="navigation" i18nKey="Support Us" />
                            </a>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default UtilityBar;
